import React, { ReactEventHandler, VFC } from 'react';
import styled from 'styled-components';
import { makeStyles, Theme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';

import SPDrawer from './SPDrawer';
import NotLoggedInContent from './NotLoggedInContent';
import NotificationIconLink from '../molecules/NotificationIconLink';
import SPLogo from '../atoms/SPLogo';
import HomeLink from '../atoms/HomeLink';

// js codes
import AccountMenu from './AccountMenu';
import SearchIconLink from '../molecules/SearchIconLink';
import ChatIconLink from '../molecules/ChatIconLink';

const RightWrapper = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
`;

const useStyles = makeStyles((theme: Theme) => ({
  iconButtonRoot: {
    color: theme.palette.primary.main,
    padding: theme.spacing(1),

    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

interface Props {
  authenticated: boolean;
  spDrawerOpen: boolean;
  imageUrl?: string | null;
  profileMenuEl: Element | null;
  handleClickSPDrawer: ReactEventHandler;
  handleOpenSPDrawer: ReactEventHandler;
  handleCloseSPDrawer: ReactEventHandler;
  handleOpenSearchDrawer: () => void;
  handleOpenProfileMenu: (anchorEl: Element | null) => void;
}
const SPHeaderContent: VFC<Props> = ({
  authenticated,
  spDrawerOpen,
  imageUrl,
  profileMenuEl,
  handleClickSPDrawer,
  handleOpenSPDrawer,
  handleCloseSPDrawer,
  handleOpenSearchDrawer,
  handleOpenProfileMenu,
}: Props) => {
  const { iconButtonRoot } = useStyles();

  return (
    <>
      <HomeLink>
        <SPLogo />
      </HomeLink>
      <IconButton
        onClick={handleClickSPDrawer}
        classes={{ root: iconButtonRoot }}
      >
        {spDrawerOpen ? <CloseIcon /> : <MenuIcon />}
      </IconButton>
      <RightWrapper>
        {authenticated ? (
          <>
            <SearchIconLink onClick={handleOpenSearchDrawer} />
            <NotificationIconLink />
            <ChatIconLink />
            <AccountMenu
              loaded={true}
              imageUrl={imageUrl}
              profileMenuEl={profileMenuEl}
              handleOpenProfileMenu={handleOpenProfileMenu}
            />
          </>
        ) : (
          <NotLoggedInContent handleOpenSearchDrawer={handleOpenSearchDrawer} />
        )}
      </RightWrapper>
      <SPDrawer
        open={spDrawerOpen}
        handleOpenSPDrawer={handleOpenSPDrawer}
        handleCloseSPDrawer={handleCloseSPDrawer}
      />
    </>
  );
};

export default SPHeaderContent;
